const mobmenuHandler = (el, menu) => {

    let mobMenuIcon = document.querySelector(el);
    let classOpen = "menu-mob-open";
    let menuToOpen = document.querySelector(menu);
    let menuEls = document.querySelectorAll(".menu-primary__li");
    

    document.addEventListener("click", (e) => {

        let target = e.target;

        if(target.closest(el)) {

            mobMenuIcon.classList.contains(classOpen) ?
            (
                mobMenuIcon.classList.remove(classOpen),
                menuToOpen.style.display = "none"
            ) : (
                mobMenuIcon.classList.add(classOpen),
                menuToOpen.style.display = "block"
            )
        }
    });

    
    menuEls.forEach( function(item) {
        
        item.addEventListener("click", (e) => {

            let subMenu = item.querySelector(".sub-menu");

            item.classList.contains(classOpen) ?
            (
                item.classList.remove(classOpen),
                subMenu.style.display = "none"
            ) : (
                menuEls.forEach( function(item) {
                    if(item.classList.contains(classOpen)) {
                        item.classList.remove(classOpen);
                        item.querySelector(".sub-menu").style.display = "none"
                    }
                }),
                item.classList.add(classOpen),
                subMenu.style.display = "block"
            )
            
        });

        let subMenuParent = item.querySelector(".menu-primary__a");

        subMenuParent.addEventListener("click", (e) => {
            e.preventDefault();
        });
    });

    window.addEventListener("resize", () => {
        if(window.innerWidth > 768) {
            
            menuToOpen.style.display = "inline-flex";
        } else if(window.innerWidth < 768) {
            menuToOpen.style.display = "none";
            mobMenuIcon.classList.remove("menu-mob-open")

        }
    });

}


export default mobmenuHandler;